import styled, { css } from 'styled-components'
import { FontSize, getLineHeightPx } from '../styles/mixins/text'
import { color } from '../styles/color'
import { BORDER_RADIUS, TEXT_SIZING_PX } from '../styles/mixins/constants'

export const Skeleton = styled.div<{
    isCircle?: boolean
    sizePx?: number
    lineHeight?: FontSize
    fontSize?: FontSize
}>`
    display: flex;
    flex: 0 0 auto;
    border-radius: ${BORDER_RADIUS};
    background: linear-gradient(
        -90deg,
        ${color.skeleton.dark} 0%,
        ${color.skeleton.light} 50%,
        ${color.skeleton.dark} 100%
    );
    background-size: 400% 400%;
    animation: pulse 1.2s ease-in-out infinite;
    @keyframes pulse {
        0% {
            background-position: 0% 0%;
        }
        100% {
            background-position: -135% 0%;
        }
    }
    height: ${(p) => {
        if (p.fontSize) {
            return TEXT_SIZING_PX[p.fontSize]
        }

        return getLineHeightPx(p.lineHeight || 'paragraph')
    }}px;
    min-width: ${(p) => p.sizePx || 100}px;
    width: ${(p) => p.sizePx || 100}px;
    ${(p) =>
        p.isCircle
            ? css`
                  border-radius: 50%;
                  width: ${p.sizePx || 0}px;
                  height: ${p.sizePx || 0}px;
              `
            : ''}
`
